import React, { Fragment, useEffect } from "react";
import classNames from "classnames";
import { Container } from "reactstrap";
import { Route, Routes, useLocation } from "react-router-dom";
import { useToasts } from 'react-toast-notifications';

import Topbar from "./Topbar";
import Dashboard from "./Dashboard";
import Schedules from "./Schedules";
import Users from "./Users";
import EssManager from "./EssManager";
import PhoneCenter from "./PhoneCenter";
import LiveMachineMap from "./LiveMachineMap";
import LiveFaults from "./LiveFaults";
import MachineTypes from "./MachineTypes";
import ErrorBoundary from "./ErrorBoundary";
import { useFullscreen } from "../Contexts/FullscreenContext";
import AuthService from "../Services/AuthService";
import { saveCurrentScreen } from "../Utils/screenTracker";

const Content = ({ sidebarIsOpen, toggleSidebar, systemChecker, user }) => {
    const { isFullscreen } = useFullscreen();
    const { addToast } = useToasts();
    const location = useLocation();
    const authService = new AuthService();

    const currentUser = user || authService.getUser() || {};
    const hasRole = (...roles) => {
        const r1 = (currentUser.role || '').toLowerCase();
        const r2 = (currentUser.role2 || '').toLowerCase();
        return roles.some(r => {
            const low = r.toLowerCase();
            return low === r1 || low === r2;
        });
    };
    const isPhoneCenterOnly = hasRole('phoneCenter') && !hasRole('admin', 'quarryManager', 'manager');
    const isITOnly = hasRole('IT') && !hasRole('admin', 'quarryManager', 'manager', 'phoneCenter', 'hrManager', 'hrManagement');

    useEffect(() => {
        saveCurrentScreen(location.pathname + location.search);
        authService.refreshUserSession();
    }, [location.pathname, location.search]);

    useEffect(() => {
    }, [systemChecker]);

    return (
        <Container
            fluid
            className={classNames("content", { "is-open": sidebarIsOpen && !isFullscreen, "is-fullscreen": isFullscreen })}
        >
            {!isFullscreen && <Topbar toggleSidebar={toggleSidebar} />}
            <div className="content-page">
                <ErrorBoundary>
                    <Routes>
                        <Route path="/" element={isPhoneCenterOnly ? <PhoneCenter /> : (isITOnly ? <Users /> : <Schedules />)}/>
                        <Route path="/schedules" element={<Schedules />}/>
                        <Route path="/users" element={<Users />}/>
                        <Route path="/phone-center" element={<PhoneCenter />}/>
                        <Route path="/ess-management" element={<EssManager />}/>
                        <Route path="/live-machines" element={<LiveMachineMap />}/>
                        <Route path="/machine-map-split" element={<LiveMachineMap />}/>
                        <Route path="/live-faults" element={<LiveFaults />}/>
                        <Route path="/live-damages" element={<LiveFaults />}/>
                        <Route path="/machine-types" element={<MachineTypes />}/>
                        <Route path="*" element={<Dashboard />}/>
                    </Routes>
                </ErrorBoundary>
            </div>
        </Container>
    );
}

export default Content;
